module.exports = __webpack_public_path__ + "static/media/howSection4Image2.0b230ac6.gif";